import React from 'react';
import { bool, string } from 'prop-types';
import { Card } from '@thd-olt-component-react/card';
import { Promo } from './Promo/Promo';
import { EmailForm } from './EmailForm/EmailForm';
import './hdhome-catalog-promo.scss';

const HdhomeCatalogPromo = ({ campaignId, formSubmission }) => {

  const secondPromoProps = {
    title: 'Enjoy 10% off',
  };

  if (formSubmission) {
    secondPromoProps.emailComponent = <EmailForm campaignId={campaignId} />;
  } else {
    secondPromoProps.link = 'http://pages.homedepot.com/styleanddecor';
    secondPromoProps.linkText = 'Sign Up';
    secondPromoProps.emailComponent = null;
  }

  const promo = (
    <Promo
      title={secondPromoProps.title}
      link={secondPromoProps.link}
      linkText={secondPromoProps.linkText}
      emailComponent={secondPromoProps.emailComponent}
    >
      <p className="hdhome-catalog-promo__item-p">
        <span className="hdhome-catalog-promo__item-span">
          Sign up for Style & Decor emails and save on your next order.
        </span>
        <span className="hdhome-catalog-promo__item-span"> Valid on select items.</span>
      </p>
    </Promo>
  );
  return (
    <div className="hdhome-catalog-promo">
      <Card>
        {promo}
        <Card.Content maxHeight="none">
          {promo}
        </Card.Content>
      </Card>
    </div>
  );
};

HdhomeCatalogPromo.propTypes = {
  campaignId: string,
  formSubmission: bool
};

HdhomeCatalogPromo.defaultProps = {
  campaignId: '',
  formSubmission: false
};

export { HdhomeCatalogPromo };
